<template>
    <div class="py-2">
        <div class="px-4 py-2" :class="{ 'input-has-error': errors && errors.hasOwnProperty('date_of_birth') }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="date_of_birth" class="text-sm">Date of Birth</label>
                </div>
                <div v-if="errors && errors.hasOwnProperty('date_of_birth')" class="flex-initial">
                    {{ errors['date_of_birth'] }}
                </div>
            </div>
            <input type="date"
                   id="date_of_birth"
                   name="date_of_birth"
                   placeholder="MM/DD/YYYY"
                   class="input-field w-full"
                   :value="date_of_birth"
                   @input="$emit('update:date_of_birth', $event.target.value)" />
        </div>
        <div class="px-4 py-2">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="annual_income" class="text-sm">Annual Income</label>
                </div>
            </div>
            <div class="flex">
                <div class="flex-initial flex items-center bg-gray-200 text-xl font-medium px-2 rounded-l">
                    $
                </div>
                <div class="flex-1">
                    <input type="text"
                        id="annual_income"
                        name="annual_income"
                        placeholder="45,000"
                        class="input-field w-full bg-gray-100 border-0 text-xl font-medium"
                        style="border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;"
                        :value="annual_income"
                        readonly
                        disabled />
                </div>
            </div>
        </div>
        <div class="px-4 py-2">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="monthly_income" class="text-sm">Monthly Income</label>
                </div>
            </div>
            <div class="flex">
                <div class="flex-initial flex items-center bg-gray-200 text-xl font-medium px-2 rounded-l">
                    $
                </div>
                <div class="flex-1">
                    <input type="text"
                           id="monthly_income"
                           name="monthly_income"
                           placeholder="45,000"
                           class="input-field w-full bg-gray-100 border-0 text-xl font-medium"
                           style="border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;"
                           :value="monthly_income"
                           readonly
                           disabled />
                </div>
            </div>
        </div>
        <div class="px-4 py-2">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label class="text-sm">Income Source</label>
                </div>
            </div>
            <div class="flex">
                <div class="flex-1">
                    <select tabindex="11"
                            id="income_source"
                            class="w-full dropdown-select border border-gray-300 text-base bg-gray-100"
                            :value="income_source"
                            disabled>
                        <option :value="null">Choose One</option>
                        <option v-for="(key, label) in incomeSources" :value="key" v-text="label" />
                    </select>
                </div>
            </div>
        </div>
        <div class="px-4 py-2" :class="{ 'input-has-error': this.hasAddressErrors() }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="address" class="text-sm">Address</label>
                </div>
                <div v-if="errors && errors.hasOwnProperty('address')" class="flex-initial">
                    {{ errors['address'][0] }}
                </div>
                <div v-else-if="errors && errors.hasOwnProperty('state')" class="flex-initial">
                    {{ errors['state'][0] }}
                </div>
            </div>
            <div class="mb-1">
                <GoogleAddressAutocomplete
                    id="address"
                    name="address"
                    placeholder="123 Lucky St"
                    inputClass="input-field w-full"
                    :value="address"
                    @update:place="updateAddress" 
                />
            </div>
            
            <div class="mb-1">
                <input type="text"
                        id="address2"
                        name="address2"
                        placeholder="Apt 1"
                        class="input-field w-full"
                        :value="address2"
                        @input="$emit('update:address2', $event.target.value)" />
            </div>

            <div v-if="selectedCity || selectedState" class="mt-2 text-sm text-gray-600 text-base">
                <span v-if="selectedCity">{{ selectedCity }}</span>
                <span v-if="selectedCity && selectedState">, </span>
                <span v-if="selectedState">{{ selectedState }}</span>
        </div>
        </div>
        <div class="px-4 py-2" :class="{ 'input-has-error': errors && errors.hasOwnProperty('zip') }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="zip" class="text-sm">Zip</label>
                </div>
                <div v-if="errors && errors.hasOwnProperty('zip')" class="flex-initial">
                    {{ errors['zip'][0] }}
                </div>
            </div>
            <input type="text"
                id="zip"
                name="zip"
                placeholder="12345"
                class="input-field w-full"
                :value="zipCode"
                @input="$emit('update:zip', $event.target.value)" />
        </div>
        <div class="px-4 py-2" :class="{ 'input-has-error': errors && errors.hasOwnProperty('phone_number') }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="phone_number" class="text-sm">Phone Number</label>
                </div>
                <div v-if="errors && errors.hasOwnProperty('phone_number')" class="flex-initial">
                    {{ errors['phone_number'] }}
                </div>
            </div>
            <input type="text"
                id="phone_number"
                name="phone_number"
                placeholder="(555) 123-9876"
                class="input-field w-full"
                :value="phone_number"
                @change="updatePhoneNumberFormat" />
        </div>
    </div>
</template>

<script>
    import GoogleAddressAutocomplete from '../../components/GoogleAddressAutocomplete.vue';

    export default {
        props: [
            'annual_income',
            'date_of_birth',
            'phone_number',
            'address',
            'address2',
            'city',
            'state',
            'zip',
            'monthly_income',
            'income_source',
            'errors'
        ],

        components: {
            GoogleAddressAutocomplete
        },

        data() {
            return {
                zipCode: '',
                selectedCity: '',
                selectedState: '',
            };
        },

        computed: {
            states() {
                return [
                    {
                        abbr: 'AL',
                        name: 'ALABAMA',
                    },
                    {
                        abbr: 'AK',
                        name: 'ALASKA',
                    },
                    {
                        abbr: 'AS',
                        name: 'AMERICAN SAMOA',
                    },
                    {
                        abbr: 'AZ',
                        name: 'ARIZONA',
                    },
                    {
                        abbr: 'AR',
                        name: 'ARKANSAS',
                    },
                    {
                        abbr: 'CA',
                        name: 'CALIFORNIA',
                    },
                    {
                        abbr: 'CO',
                        name: 'COLORADO',
                    },
                    {
                        abbr: 'CT',
                        name: 'CONNECTICUT',
                    },
                    {
                        abbr: 'DE',
                        name: 'DELAWARE',
                    },
                    {
                        abbr: 'DC',
                        name: 'DISTRICT OF COLUMBIA',
                    },
                    {
                        abbr: 'FL',
                        name: 'FLORIDA',
                    },
                    {
                        abbr: 'GA',
                        name: 'GEORGIA',
                    },
                    {
                        abbr: 'GU',
                        name: 'GUAM GU',
                    },
                    {
                        abbr: 'HI',
                        name: 'HAWAII',
                    },
                    {
                        abbr: 'ID',
                        name: 'IDAHO',
                    },
                    {
                        abbr: 'IL',
                        name: 'ILLINOIS',
                    },
                    {
                        abbr: 'IN',
                        name: 'INDIANA',
                    },
                    {
                        abbr: 'IA',
                        name: 'IOWA',
                    },
                    {
                        abbr: 'KS',
                        name: 'KANSAS',
                    },
                    {
                        abbr: 'KY',
                        name: 'KENTUCKY',
                    },
                    {
                        abbr: 'LA',
                        name: 'LOUISIANA',
                    },
                    {
                        abbr: 'ME',
                        name: 'MAINE',
                    },
                    {
                        abbr: 'MD',
                        name: 'MARYLAND',
                    },
                    {
                        abbr: 'MA',
                        name: 'MASSACHUSETTS',
                    },
                    {
                        abbr: 'MI',
                        name: 'MICHIGAN',
                    },
                    {
                        abbr: 'MN',
                        name: 'MINNESOTA',
                    },
                    {
                        abbr: 'MS',
                        name: 'MISSISSIPPI',
                    },
                    {
                        abbr: 'MO',
                        name: 'MISSOURI',
                    },
                    {
                        abbr: 'MT',
                        name: 'MONTANA',
                    },
                    {
                        abbr: 'NE',
                        name: 'NEBRASKA',
                    },
                    {
                        abbr: 'NV',
                        name: 'NEVADA',
                    },
                    {
                        abbr: 'NH',
                        name: 'NEW HAMPSHIRE',
                    },
                    {
                        abbr: 'NJ',
                        name: 'NEW JERSEY',
                    },
                    {
                        abbr: 'NM',
                        name: 'NEW MEXICO',
                    },
                    {
                        abbr: 'NY',
                        name: 'NEW YORK',
                    },
                    {
                        abbr: 'NC',
                        name: 'NORTH CAROLINA',
                    },
                    {
                        abbr: 'ND',
                        name: 'NORTH DAKOTA',
                    },
                    {
                        abbr: 'OH',
                        name: 'OHIO',
                    },
                    {
                        abbr: 'OK',
                        name: 'OKLAHOMA',
                    },
                    {
                        abbr: 'OR',
                        name: 'OREGON',
                    },
                    {
                        abbr: 'PA',
                        name: 'PENNSYLVANIA',
                    },
                    {
                        abbr: 'PR',
                        name: 'PUERTO RICO',
                    },
                    {
                        abbr: 'RI',
                        name: 'RHODE ISLAND',
                    },
                    {
                        abbr: 'SC',
                        name: 'SOUTH CAROLINA',
                    },
                    {
                        abbr: 'SD',
                        name: 'SOUTH DAKOTA',
                    },
                    {
                        abbr: 'TN',
                        name: 'TENNESSEE',
                    },
                    {
                        abbr: 'TX',
                        name: 'TEXAS',
                    },
                    {
                        abbr: 'UT',
                        name: 'UTAH',
                    },
                    {
                        abbr: 'VT',
                        name: 'VERMONT',
                    },
                    {
                        abbr: 'VA',
                        name: 'VIRGINIA',
                    },
                    {
                        abbr: 'WA',
                        name: 'WASHINGTON',
                    },
                    {
                        abbr: 'WV',
                        name: 'WEST VIRGINIA',
                    },
                    {
                        abbr: 'WI',
                        name: 'WISCONSIN',
                    },
                    {
                        abbr: 'WY',
                        name: 'WYOMING',
                    }
                ];
            },

            incomeSources() {
                return JSON.parse(window.income_sources);
            },
        },

        mounted() {
            this.zipCode = this.zip;
        },

        methods: {

            hasAddressErrors() {
                return this.errors && 
                (
                    this.errors.hasOwnProperty('address') || 
                    this.errors.hasOwnProperty('state')
                );
            },

            updateAddress(formatedAddress, placeObject) {
                this.zipCode = placeObject?.zip ?? '';
                this.selectedCity = placeObject?.city ?? '';
                this.selectedState = placeObject?.state ?? '';
                this.$emit('update:address', placeObject);
            },
            /**
             * @param event
             * @returns {void}
             */
            updatePhoneNumberFormat(event) {
                this.$emit('update:phone_number', this.$options.filters.phone(event.target.value));
            }
        }
    }
</script>